import LogoImg from 'assets/images/logo/logo_alt.png';
import { getRouteHomePage } from 'modules/dashboard/routes/navigation';
import { getRouteWelcomeJourney } from 'modules/v2/routes/navigation';
import { getItem } from 'modules/dashboard/utils/legacy';

import { Button, ButtonGroup, Dropdown, Title, UserMenu, Menu, SitesDropdown } from './components';
import S from './styles';

const NavBar = ({ mainContent, sideContent, fixed, hasSeparator }) => (
  <S.Wrapper fixed={fixed}>
    <S.Wrapper.Main>
      <S.Logo to={getRouteHomePage}>
        <img src={LogoImg} alt="Authorify Logo" />
      </S.Logo>
      <S.Separator showLine={hasSeparator} />
      {mainContent}
    </S.Wrapper.Main>
    <S.Wrapper.Side>{sideContent}</S.Wrapper.Side>
  </S.Wrapper>
);

NavBar.Button = Button;
NavBar.ButtonGroup = ButtonGroup;
NavBar.Dropdown = Dropdown;
NavBar.Title = Title;
NavBar.UserMenu = UserMenu;
NavBar.Menu = Menu;
NavBar.SitesDropdown = SitesDropdown;

export default NavBar;
